// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Kx5QEWHfHxirb7xC3_YQZ{margin:0;margin-right:.5rem;font-size:.875rem}button._2Rqw47GRXsAgufMlDTYexG{cursor:pointer}._2Rqw47GRXsAgufMlDTYexG{display:flex;padding:4px 12px;font-size:.875rem;line-height:1.25rem;box-shadow:inset 0 1px 2px rgba(255,255,255,.15),0 1px 2px rgba(0,0,0,.08);border-style:none;white-space:nowrap;border-radius:1rem;font-weight:400;color:#120a20;background-color:rgba(255,255,255,.85);border-color:#fff}._2Rqw47GRXsAgufMlDTYexG:focus{outline:none}._2Rqw47GRXsAgufMlDTYexG.ud1NY9ICVS4In0RyZ8Jay{padding:6px 12px;font-size:.875rem !important;background-color:#fff}._2Rqw47GRXsAgufMlDTYexG:not(._25PjQaYZ8VA6HgwItfhd_l):hover{color:#120a20;background-color:#ececec;border-color:#e6e6e6}._2Rqw47GRXsAgufMlDTYexG strong{font-weight:600;margin-right:8px}._3zpi6PQFZRTumrB3qV7BeH{font-weight:600}", ""]);
// Exports
exports.locals = {
	"headerDescription": "Kx5QEWHfHxirb7xC3_YQZ",
	"headerButton": "_2Rqw47GRXsAgufMlDTYexG",
	"login": "ud1NY9ICVS4In0RyZ8Jay",
	"noHover": "_25PjQaYZ8VA6HgwItfhd_l",
	"email": "_3zpi6PQFZRTumrB3qV7BeH"
};
module.exports = exports;
